import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectPageType } from '../../selectors/page';
import { EPageType } from '../../types/page';
import { VacancyContainer } from '../Vacancy';
import { ListingContainer } from '../Listing';
import {
  CareerPersonDanilPage,
  CareerPersonNikitaPage,
  CareerPersonNataliaPage,
  CareerPersonDimaPage,
  CareerPersonVeronicaPage,
  CareerPage,
  CareerVacanciesPage,
  CareerVacancyPage,
  CareerTeamMarketingPage,
  CareerTeamAnalyticsPage,
  CareerTeamTechnologiesPage,
  CareerTeamProductPage,
  CareerTeamBackofficePage,
} from 'career-entry';
import { NoSsr } from '@cian/react-utils';

export const PageContainer: React.FC = () => {
  const pageType = useSelector(selectPageType);

  switch (pageType) {
    case EPageType.CareerPersonDanil:
      return <CareerPersonDanilPage />;
    case EPageType.CareerPersonNikita:
      return <CareerPersonNikitaPage />;
    case EPageType.CareerPersonNatalia:
      return <CareerPersonNataliaPage />;
    case EPageType.CareerPersonDima:
      return <CareerPersonDimaPage />;
    case EPageType.CareerPersonVeronica:
      return <CareerPersonVeronicaPage />;
    case EPageType.Career:
      return <CareerPage />;
    case EPageType.CareerVacancies:
      return <CareerVacanciesPage />;
    case EPageType.CareerVacancy:
      return <CareerVacancyPage />;
    case EPageType.CareerTeamMarketing:
      return <CareerTeamMarketingPage />;
    case EPageType.CareerTeamTechnologies:
      return <CareerTeamTechnologiesPage />;
    case EPageType.CareerTeamProduct:
      return <CareerTeamProductPage />;
    case EPageType.CareerTeamBackoffice:
      return <CareerTeamBackofficePage />;
    case EPageType.CareerTeamAnalytics:
      return <CareerTeamAnalyticsPage />;
    case EPageType.Card:
      return (
        <NoSsr>
          <VacancyContainer />
        </NoSsr>
      );
    case EPageType.Listing:
      return (
        <NoSsr>
          <ListingContainer />
        </NoSsr>
      );
    default:
      return null;
  }
};

PageContainer.displayName = 'PageContainer';
